import ReactGA from "react-ga4";
import {GoogleAnalyticsEventCategory, GoogleAnalyticsEventType} from "../models/google-analytics";
import {handleInitializeCookieConsent} from "./cookie-consent-service";

/** TRACKOWANIE EVENTÓW */
export function trackEvent(eventType: GoogleAnalyticsEventType) {
    handleInitializeGA4();
    handleInitializeCookieConsent();
    handleTrackEvent(eventType);
}

function handleInitializeGA4() {
    console.log("Initializing Google Analytics");

    // JEŚLI NIE ZOSTAŁ ZAINICJALIZOWANY GA-4
    if (!ReactGA.isInitialized) {
        // GOOGLE GA-4 INITIALIZE
        ReactGA.initialize("G-XK3JNR74PF");
        console.log("Google Analytics initialized");

        // GOOGLE GTAG INITIALIZE
        ReactGA.gtag('consent', 'default', {
            'ad_storage': 'granted',
            'ad_user_data': 'granted',
            'ad_personalization': 'granted',
            'analytics_storage': 'granted'
        });
        console.log("Google GTAG initialized");
    }

    // JEŚLI JUŻ WCZEŚNIEJ ZAINICJALIZOWANO
    else {
        console.log("Google Analytics already initialized");
    }
}

function handleTrackEvent(eventType: GoogleAnalyticsEventType) {
    ReactGA.event({
        category: GoogleAnalyticsEventCategory.FakturomaniaWebsite,
        action: eventType,
        label: 'success'
    });
}

export function handleUpdateGA4Consent(
    analytics: boolean,
    advertising: boolean
) {
    // JEŚLI NIE ZOSTAŁ ZAINICJALIZOWANY GA-4
    if (!ReactGA.isInitialized) {
        // GOOGLE GA-4 INITIALIZE
        ReactGA.initialize("G-XK3JNR74PF");
    }

    // GOOGLE GTAG INITIALIZE
    ReactGA.gtag('consent', 'update', {
        'ad_storage': advertising ? 'granted' : 'denied',
        'ad_user_data': advertising ? 'granted' : 'denied',
        'ad_personalization': advertising ? 'granted' : 'denied',
        'analytics_storage': analytics ? 'granted' : 'denied'
    });
}


// WEBPACK FOOTER //
// ./src/services/google-analytics-service.ts